import styled from 'styled-components'

import { Colors } from 'common-constants/colors'
import { media } from 'components/presentational'
import { ButtonLink } from 'components/presentational/link'
import { ProfileName } from 'components/presentational/ProfileName/ProfileName'
import { AddToFavoritesSvg } from 'components/presentational/svg/AddToFavoritesSvg'
import { mobileModalPaddingSize } from 'components/storefront/StoreFrontFeaturedPhotos/FeaturedPhotos.constants'

export const CustomButtonLink = styled(ButtonLink)`
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
`

export const ContactsWrapperList = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: var(--static-white);
  position: relative;
  touch-action: auto;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-drag: none;

  ${media.phone`
     margin: 0 -${mobileModalPaddingSize}px; 
  `};

  div:focus {
    outline: 0;
  }

  & > {
    /* Фиксит https://youtrack.mamba.ru/issue/M-8480 */
    height: 100%;
  }
`

export const ContactsListWrapper = styled.section`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
`

export const StyledProfileName = styled(ProfileName)`
  font-weight: bold;
  line-height: 1.25;
  flex-wrap: wrap;
  color: var(--static-black);
  margin-bottom: 5px;

  &:hover,
  &:focus {
    color: ${Colors.linkSelected};
  }
`

/**
 * Нужно для скрытия второго скролла на десктопе.
 * overflow: hidden;
 */
export const ContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-grow: 1;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: ${Colors.contactScrollBar};
  }

  &::-webkit-scrollbar-track {
    width: 5px;
  }

  ${media.tabletLarge`
     max-height: none;
     margin: 0;
     overflow: visible;
  `};
`

export const FavoriteSvgPresetService = styled(AddToFavoritesSvg)`
  & path {
    stroke: transparent;
  }
`
